// ======================================
//   SHIPPING ADDRESS PAGE (LUXURY UI)
// ======================================

import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { RootState, AppDispatch } from "../redux/store";
import { fetchUserData } from "../redux/authSlice";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";


const ShippingAddress: React.FC = () => {
const location = useLocation();
const navigate = useNavigate();

const guestId = location.state?.guestId;
  const dispatch = useDispatch<AppDispatch>();

  const user = useSelector((state: RootState) => state.auth.user);
  const loading = useSelector(
    (state: RootState) => state.auth.status === "loading"
  );

useEffect(() => {
  if (guestId) {
    dispatch(fetchUserData(guestId));
  }
}, [dispatch, guestId]);



  // ✅ Correct shipping address
  const shipping = user?.shippingAddress;

  return (
    <div style={styles.wrapper}>
      {/* HEADER */}
      <div style={styles.header}>
        <button onClick={() => navigate(-1)} style={styles.backBtn}>
          <ArrowBackIosNewIcon style={{ fontSize: 18, color: "#bf9b30" }} />
        </button>

        <h2 style={styles.title}>Shipping Address</h2>
      </div>

      {/* LOADING */}
      {loading && <p style={styles.loading}>Loading address…</p>}

      {/* NO ADDRESS */}
      {!loading && !shipping && (
        <p style={styles.empty}>No shipping address saved.</p>
      )}

      {/* ADDRESS CARD */}
      {shipping && (
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          style={styles.card}
        >
          <div style={styles.row}>
            <span style={styles.key}>Street Address:</span>
            <span style={styles.value}>{shipping.streetAddress}</span>
          </div>

          <div style={styles.row}>
            <span style={styles.key}>Apartment Number:</span>
            <span style={styles.value}>{shipping.apartmentNumber}</span>
          </div>

          <div style={styles.row}>
            <span style={styles.key}>Postal Address (P.O. Box):</span>
            <span style={styles.value}>{shipping.postalAddress}</span>
          </div>

          <div style={styles.row}>
            <span style={styles.key}>City:</span>
            <span style={styles.value}>{shipping.city}</span>
          </div>

          <div style={styles.row}>
            <span style={styles.key}>State:</span>
            <span style={styles.value}>{shipping.state}</span>
          </div>

          <div style={styles.row}>
            <span style={styles.key}>Country:</span>
            <span style={styles.value}>{shipping.country}</span>
          </div>

          <div style={styles.row}>
            <span style={styles.key}>Postal Code / Zip:</span>
            <span style={styles.value}>{shipping.zipCode}</span>
          </div>
        </motion.div>
      )}
    </div>
  );
};

export default ShippingAddress;

// --------------------------------------------------
// 🎨 Styles — Luxury Black + Gold
// --------------------------------------------------
const styles: Record<string, React.CSSProperties> = {
  wrapper: {
    minHeight: "100vh",
    background: "#000",
    color: "#fff",
    padding: 20,
    fontFamily: "Poppins, sans-serif",
  },

  header: {
    height: 70,
    display: "flex",
    alignItems: "center",
    gap: 20,
    borderBottom: "1px solid rgba(191,155,48,0.3)",
    position: "sticky",
    top: 0,
    background: "#000",
    zIndex: 10,
  },

  backBtn: {
    width: 40,
    height: 40,
    borderRadius: "50%",
    background: "rgba(255,255,255,0.05)",
    border: "1px solid rgba(191,155,48,0.25)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
  },

  title: {
    fontSize: 22,
    color: "#bf9b30",
    fontWeight: 600,
  },

  loading: { color: "#bbb", marginTop: 40 },
  empty: { color: "#777", marginTop: 40 },

  card: {
    background: "linear-gradient(145deg, #0a0a0a, #111)",
    padding: 22,
    borderRadius: 18,
    marginTop: 28,
    maxWidth: 550,
    border: "1px solid rgba(191,155,48,0.25)",
  },

  row: {
    display: "flex",
    justifyContent: "space-between",
    padding: "10px 0",
    borderBottom: "1px solid rgba(255,255,255,0.06)",
  },

  key: { color: "#bf9b30", fontWeight: 500 },
  value: { color: "#ddd" },
};
